import axiosInstance from '../utils/axios-instance';
import { actionCreator, createRequestTypes } from '../utils/helpers';
import { getErrorMessage } from '../utils/helpers';

export const VALIDATE_SIGNUP_TOKEN = createRequestTypes('VALIDATE_SIGNUP_TOKEN');
export const GET_ORDER_AVAILABILITY = createRequestTypes('GET_ORDER_AVAILABILITY');
export const GET_ORDER_APPOINTMENTS = createRequestTypes('GET_ORDER_APPOINTMENTS');
export const POST_ORDER_APPOINTMENT = createRequestTypes('POST_ORDER_APPOINTMENT');
export const COMPLETE_SIGNUP_TO_SERVICE = createRequestTypes('COMPLETE_SIGNUP_TO_SERVICE');

export const validateSignupForServiceToken = (verificationToken) => async (dispatch, getState) => {
    dispatch(actionCreator.request(VALIDATE_SIGNUP_TOKEN));
    try {
        const response = await axiosInstance.post(`/verification/email/signupforservicetokenverify`, {verificationToken});
        dispatch(actionCreator.success(VALIDATE_SIGNUP_TOKEN, response.data));
        return response;
    } catch (err) {
        let language = getState().language.language;
        let mockError = getErrorMessage(err.response, language);
        dispatch(actionCreator.failure(VALIDATE_SIGNUP_TOKEN, mockError));
        return err.response;
    }
};

export const getOrderAvailability = (orderId) => async (dispatch) => {
    dispatch(actionCreator.request(GET_ORDER_AVAILABILITY));
    try {
        const response = await axiosInstance.get(`/appointments/service-order/${orderId}/availability`);
        dispatch(actionCreator.success(GET_ORDER_AVAILABILITY, response.data));
    } catch (err) {
        let mockError = {message: 'Not found'};
        dispatch(actionCreator.failure(GET_ORDER_AVAILABILITY, mockError));
    }
};

export const createOrderAppointment = (orderId, data) => async (dispatch) => {
    dispatch(actionCreator.request(POST_ORDER_APPOINTMENT));
    try {
        const response = await axiosInstance.post(`/public/order/${orderId}/appointment`, data);
        dispatch(actionCreator.success(POST_ORDER_APPOINTMENT, response.data));
        return response;
    } catch (err) {
        dispatch(actionCreator.failure(POST_ORDER_APPOINTMENT));
        return err;
    }
};

export const completeSignupToService = (verificationToken) => async (dispatch, getState) => {
    dispatch(actionCreator.request(COMPLETE_SIGNUP_TO_SERVICE));
    try {
        const response = await axiosInstance.post(`/verification/email/completesignupforservice`, {verificationToken});
        dispatch(actionCreator.success(COMPLETE_SIGNUP_TO_SERVICE, response.data));
        return response;
    } catch (err) {
        let language = getState().language.language;
        let mockError = getErrorMessage(err.response, language);
        dispatch(actionCreator.failure(COMPLETE_SIGNUP_TO_SERVICE, mockError));
        return err.response;
    }
};